var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageHeader',{attrs:{"page-name":"FAQ"}},[[_c('router-link',{attrs:{"to":{name: 'CreateFAQ'}}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v(" Создать Вопрос/Ответ ")])],1)]],2),_c('MainPanel',[_c('List',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }